<template>
  <div class="footer">
    <div class="contact"></div>
    <div class="bottom">
      <el-row>
        <el-col :xs="12" :sm="12" :md="5" :lg="5" :xl="5" :span="5" class="bottom-flex align-center pl0">
          <el-image class="bottom-img1 mb18" :src="require('@/assets/images/yellow-logo.png')" fit="fill"></el-image>
          <el-image class="bottom-img2" :src="require('@/assets/images/noodle-chopsticks.png')" fit="fill"></el-image>
          <el-image class="bottom-img1" :src="require('@/assets/images/design.png')" fit="fill"></el-image>
        </el-col>
        <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" :span="4">
          <div class="changeLang">
            <span @click="changLang('zh')" :class="[ lang === 'zh' ? 'black' : '']">Chinese</span>
            <el-divider direction="vertical"></el-divider>
            <span @click="changLang('en')" :class="[ lang === 'en' ? 'black' : '']">English</span>
          </div>
          <el-image class="wechat-img" :src="require('@/assets/images/wechat.jpg')" fit="fill"></el-image>
        </el-col>
        <el-col :xs="8" :sm="8" :md="4" :lg="4" :xl="4" :span="4" class="bottom-flex font-link">
          <h4>{{ lang === 'zh' ? '探寻' : 'Explore' }}</h4>
          <el-link href="/solution" :underline="false">{{ lang === 'zh' ? '品牌故事' : 'Brand story' }}</el-link>
          <el-link href="https://account.yitianyun.cn/wap/477/pagesCustom/index/index?pageId=2085" target="_blank"
            :underline="false">{{ lang === 'zh' ? '联系我们' : 'Contact us' }}</el-link>
          <el-link href="https://mp.weixin.qq.com/s?__biz=Mzg3OTc2MTc5OQ==&mid=2247485143&idx=1&sn=1000141ecde9ed2c60c0c44f460e34b3&chksm=cf7ec63ff8094f29368e7b15d7a4ced814ab5ed9dd5a6453ef6ba234a5327ea8519c92bd7c11#rd" target="_blank" :underline="false">
            {{ lang === 'zh' ? '加入我们' : 'Join us' }}</el-link>
        </el-col>
        <el-col :xs="8" :sm="8" :md="4" :lg="4" :xl="4" :span="4" class="bottom-flex font-link" style="height: auto;">
          <h4>{{ lang === 'zh' ? '泡面世界' : 'Instant Noodles World' }}</h4>
          <el-link href="https://unclenoodle.taobao.com/" target="_blank" :underline="false">{{ lang === 'zh' ? '官方商城' : 'official Mall' }}</el-link>
          <el-popover placement="right" width="400" trigger="click">
            <el-image class="bottom-img1 mb18" :src="require('@/assets/images/tiktok.png')" fit="fill"></el-image>
            <el-link slot="reference" href="javascript:void(0)" :underline="false">
              {{ lang === 'zh' ? '官方抖音' : 'Official Tik Tok' }}</el-link>
          </el-popover>
          <el-popover placement="right" width="260" trigger="click">
            <el-image class="bottom-img1 mb18" :src="require('@/assets/images/wechat.jpg')" fit="fill"></el-image>
            <el-link slot="reference" href="javascript:void(0)" :underline="false">
              {{ lang === 'zh' ? '官方公众号' : 'Official Wechat Account' }}</el-link>
          </el-popover>
          <el-popover placement="right" width="400" trigger="click">
            <el-image class="bottom-img1 mb18" :src="require('@/assets/images/redBook.png')" fit="fill"></el-image>
            <el-link slot="reference" href="javascript:void(0)" :underline="false">
              {{ lang === 'zh' ? '官方小红书' : 'Official Little Red Book' }}</el-link>
          </el-popover>
          <el-popover placement="right" width="260" trigger="click">
            <el-image class="bottom-img1 mb18" :src="require('@/assets/images/wechatApp.jpg')" fit="fill"></el-image>
            <el-link slot="reference" href="javascript:void(0)" :underline="false">
              {{ lang === 'zh' ? '官方小程序' : 'Official Wechat Applet' }}</el-link>
          </el-popover>
        </el-col>
        <el-col :xs="8" :sm="8" :md="4" :lg="4" :xl="4" :span="4" class="bottom-flex font-link">
          <h4>{{ lang === 'zh' ? '指引' : 'Guidelines' }}</h4>
          <el-link href="https://account.yitianyun.cn/wap/477/pagesCustom/index/index?pageId=2285" target="_blank" :underline="false">{{ lang === 'zh' ? '自助烹饪机操作指引' : 'Operation guide for self cooking machine' }}</el-link>
        </el-col>
      </el-row>
    </div>
    <div id="beian">
      Copyright © 2023. 官网｜泡面大叔 Uncle Noodle All Rights Reserved.<br/>
      <a href="https://beian.miit.gov.cn" target="_blank">闽ICP备2022004824号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    lang: {
      type: String,
      default: 'zh'
    },
    hash: String
  },
  data() {
    return {
      isShow: true
    }
  },
  methods: {
    changLang(str) {
      this.$emit('changLang', str)
    }
  }
}
</script>

<style lang="less">
.footer {
  background-color: #ebebeb;
  width: 100%;
  margin-top: -202px;
  box-sizing: border-box;
  height: 202px;

  .middle {
    width: 100%;
    margin: 0 auto;
  }
}

.contact {
  width: calc(100% - 68px);
  background: rgba(195, 195, 195, 1);
  height: 103px;
  line-height: 103px;
  margin: 0 auto;
}

.bottom {
  margin-top: 50px;
  background: rgba(235, 235, 235, 1);
  text-align: left;
  color: #111111;
  padding: 44px 0;

  .el-col {
    height: 236px;
  }

  .bottom-flex {
    display: flex;
    flex-direction: column;
    // padding-left: 30px !important;

    h4 {
      margin-top: 24px;
    }

    .bottom-img1 {
      width: 68px;
      height: 68px;
    }

    .bottom-img2 {
      width: 78px;
      height: 68px;
      margin-bottom: 18px;
    }

    .mb18 {
      margin-bottom: 18px;
    }

    .el-link {
      justify-content: left;
      margin-top: 18px;
    }
  }

  .pl0 {
    padding-left: 0px !important;
  }

  .changeLang {
    cursor: pointer;
    margin: 24px auto;

    span {
      color: rgb(186, 183, 183);
    }

    .black {
      color: #000000;
    }

    .el-divider {
      background-color: #111111;
    }
  }

  .wechat-img {
    width: 112px;
    height: 112px;
    margin-top: 10px;
  }

  .align-center {
    align-items: center;
  }
}
#beian {
  text-align: center;
  padding-bottom: 6px;
  font-size: 12px;
  color: #111111;
  z-index: 999;
  background-color: rgb(235, 235, 235);
  a {
    color: #00aaee;
  }
}
@media (max-width: 768px){
  .contact {
    height: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue